"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimisticMarkAllAsRead = exports.optimisticMarkAsRead = exports.MARK_ALL_AS_READ = exports.updateNotificatonsOnMarkAsRead = exports.MARK_AS_READ = void 0;
const client_1 = require("@apollo/client");
const restricted_1 = require("../../query/restricted");
exports.MARK_AS_READ = (0, client_1.gql) `
  mutation MarkNotificationAsread($id: Int!) {
    restricted {
      markNotificationAsRead(id: $id) {
        id
        read
      }
    }
  }
`;
const updateNotificatonsOnMarkAsRead = (cache, result, options) => {
    const { markNotificationAsRead } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !markNotificationAsRead) {
        return;
    }
    const { read } = markNotificationAsRead || {};
    if (read) {
        const prevData = cache.readQuery({
            query: restricted_1.NOTIFICATIONS,
        });
        if (prevData) {
            const { id: notificationId } = variables;
            const { notifications } = prevData.restricted;
            const index = notifications.findIndex(({ id }) => Number(id) === Number(notificationId));
            const updatedNotications = [
                ...notifications.slice(0, index),
                { ...notifications[index], read: true },
                ...notifications.slice(index + 1),
            ].sort((n1, n2) => {
                if (n1.read === n2.read) {
                    return n1.createdAt > n2.createdAt ? -1 : 1;
                }
                return n1.read ? 1 : -1;
            });
            cache.writeQuery({
                query: restricted_1.NOTIFICATIONS,
                data: {
                    ...prevData,
                    restricted: {
                        ...prevData.restricted,
                        notifications: updatedNotications,
                    },
                },
            });
        }
    }
};
exports.updateNotificatonsOnMarkAsRead = updateNotificatonsOnMarkAsRead;
exports.MARK_ALL_AS_READ = (0, client_1.gql) `
  mutation MarkAllNotificationsAsRead {
    restricted {
      markAllNotificationsAsRead {
        id
        read
      }
    }
  }
`;
const optimisticMarkAsRead = (notification) => () => ({
    restricted: {
        __typename: 'RestrictedMutation',
        markNotificationAsRead: {
            ...notification,
            read: true,
        },
    },
});
exports.optimisticMarkAsRead = optimisticMarkAsRead;
const optimisticMarkAllAsRead = (notifications = []) => () => {
    const index = notifications.findIndex(({ read }) => read);
    const updatedNotification = notifications
        .slice(0, index)
        .map((notification) => ({ ...notification, read: true }));
    return {
        restricted: {
            __typename: 'RestrictedMutation',
            markAllNotificationsAsRead: [
                ...updatedNotification,
                ...notifications.slice(index).sort((n1, n2) => {
                    if (n1.read === n2.read) {
                        return n1.createdAt < n2.createdAt ? -1 : 1;
                    }
                    return n1.read ? 1 : -1;
                }),
            ],
        },
    };
};
exports.optimisticMarkAllAsRead = optimisticMarkAllAsRead;
